import InnerBox from '@repo/ui/inner-box'

import { API, constructApiUrl } from '../../../../api/apis.config'
import useTranslate from '../../../../lib/hooks/use-translate'
import { MobileNumberForFrenchLeader } from '../../../../lib/types/models/ol/mobile-number-for-french-leader/mobile-number-for-french-leader'
import { getMobileNumberForFrenchLeadersColumns } from '../../../../views/ol-personal-space/mobile-number-for-french-leaders/utils'
import DynamicDataTable from '../../../elements/dynamic-table'

type Props = {
  olId: number
}
const OlMobileNumberForFrenchLeadersListPage = ({ olId }: Props) => {
  const { t } = useTranslate()

  return (
    <InnerBox className="rounded-2xl p-0">
      <DynamicDataTable<MobileNumberForFrenchLeader, null>
        title={'Portable du responsable'}
        columns={getMobileNumberForFrenchLeadersColumns(t)}
        allowSearchParam
        permissions={{ delete: false }}
        endpoint={constructApiUrl(API.ols.getMobileNumberForFrenchLeaders.url, { olId: +olId })}
      />
    </InnerBox>
  )
}

export default OlMobileNumberForFrenchLeadersListPage
